import React, { forwardRef } from 'react'
import styled from 'react-emotion'
import {
  interactive as interactiveStyles,
  rowHeight,
  border,
  color
} from '../style'
import { Link } from 'react-router-dom'
// import isPropValid from '@emotion/is-prop-valid'

export const Row = styled(
  forwardRef(
    (
      {
        className,
        as,
        top,
        bottom,
        xLarge,
        noPad,
        flex,
        grey,
        white,
        interactive,
        z,
        ...props
      },
      ref
    ) => {
      const Component = as || 'div'
      return <Component {...props} className={className + ' row'} ref={ref} />
    }
  )
)(props => {
  const {
    top,
    bottom,
    xLarge,
    noPad,
    flex,
    grey,
    white,
    interactive,
    z
  } = props
  const height = xLarge
    ? rowHeight.extraLarge
    : // : large
      // ? rowHeight.large
      rowHeight.default
  const spacing = xLarge
    ? 20
    : // : large
      // ? ??
      10
  let style = {
    label: 'Row',
    display: 'flex',
    flex: flex === true ? 1 : flex,
    flexDirection: 'row',
    alignItems: 'center',
    height,
    minHeight: height, // also needed to stop flexbox squishing it
    width: '100%',
    maxWidth: '100vw', // prevent overflow on small screen
    margin: 0,

    fontWeight: 500,
    fontSize: xLarge && 16,

    background: white ? 'white' : grey ? color.hover : 'transparent',
    borderBottom: top && border,
    borderTop: bottom && border,

    zIndex: z && 1,

    padding: xLarge && !noPad && '0 10px',

    '& > *': noPad
      ? {
          '&:not(:last-child)': { marginRight: spacing / 2 },
          '&:not(:first-child)': { marginLeft: spacing / 2 }
        }
      : {
          marginRight: spacing / 2,
          marginLeft: spacing / 2
        },
    // piss off react-shortcuts
    '.react-shortcuts': { margin: 0 }
  }
  if (interactive) style = { ...style, ...interactiveStyles(props) }
  return style
})

export const RowSet = styled('div')({
  label: 'RowSet',
  display: 'flex',
  '.row': { width: 'auto' }
})
export const RowSpacer = styled('span')({
  label: 'RowSpacer',
  flex: 1
})

export default Row

// const shouldForwardProp = prop =>
//   !['stretch', 'primary', 'notSelected', 'danger'].includes(prop) &&
//   isPropValid(prop)

export const RowButton = forwardRef((props, ref) => {
  const component = props.to ? Link : props.href ? 'a' : undefined
  return <Row interactive as={component} innerRef={ref} {...props} />
})
